"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const moment_1 = tslib_1.__importDefault(require("moment"));
const utils_1 = require("@osmosys/utils");
const file_saver_1 = require("file-saver");
const react_use_1 = require("react-use");
const hooks_1 = require("../hooks");
exports.EmailCanvasToolbarDownloadHtmlButton = () => {
    const { state: { draftEmail: draft }, } = hooks_1.useEmailCanvasContext();
    // Number of times pressed:
    const [downloadsNumber, downloadsNumberActions] = react_use_1.useNumber(1);
    // File name:
    const filename = react_2.useMemo(() => {
        return utils_1.osmosysSlugify(`osmosys-email-${draft.emailNumber}--${draft.name ||
            'no name'}--download-${downloadsNumber}--date-${moment_1.default().format('MMM-D-YYYY-HH-mm-ss')}.html`);
    }, [draft.emailNumber, draft.name, downloadsNumber]);
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: `EmailCanvasToolbar.downloadHtml.${downloadsNumber}`, onClick: () => {
            downloadsNumberActions.inc(1);
            const blob = new Blob([draft.html], {
                type: 'text/html;charset=utf-8',
            });
            file_saver_1.saveAs(blob, filename);
        }, disabled: !draft.html, osysIcon: "download", tooltip: draft.html ? `Download ${filename}` : 'There is no HTML to download' }));
};
//# sourceMappingURL=DownloadHtmlButton.js.map